import { Anchor, Group, List } from "@mantine/core"
import { Button } from "@tfg/ui"
import { useCallback, useEffect, useMemo, useState } from "react"

import { InlineBanner } from "~/components/InlineBanner"
import { FindIngestionErrorLogsResponseDto } from "~/gen/api"

type Props = {
  errorLogs: FindIngestionErrorLogsResponseDto
}

export function ErrorPreview({ errorLogs }: Props) {
  const [showFullList, setShowFullList] = useState(false)
  const previewLimit = 4

  const errors = useMemo(() => {
    return Object.entries(errorLogs.content).map((error) => {
      return { title: [error[0]], error: error[1] }
    })
  }, [errorLogs.content])

  const handleDownloadErrors = useCallback(() => {
    const errorText = errors
      .map((error) => `Error : ${error.title} ; ${error.error}\n`)
      .join("\n")

    const element = document.createElement("a")
    const file = new Blob([errorText], { type: "text/plain" })
    element.href = URL.createObjectURL(file)
    element.download = "errors.txt"
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }, [errors])

  useEffect(() => {
    setShowFullList(false)
  }, [errorLogs])

  return (
    <InlineBanner
      type="error"
      message={`Found ${errors.length} errors in file`}
      closable={false}
    >
      <List c="red" fz="xs">
        {errors
          .slice(0, showFullList ? errors.length : previewLimit)
          .map((error, index) => (
            <List.Item key={index}>
              <strong>{error.title}</strong> : {error.error}
            </List.Item>
          ))}
      </List>
      <Group justify="space-between" w="100%" align="end">
        {!showFullList && errors.length > previewLimit && (
          <Anchor c="red" fz="xs" onClick={() => setShowFullList(true)}>
            Show More
          </Anchor>
        )}
        <Button
          bg="white"
          variant="secondary-critical"
          onClick={handleDownloadErrors}
        >
          Download Full List as .txt
        </Button>
      </Group>
    </InlineBanner>
  )
}
